import { useElementSize } from '@mantine/hooks'
import { PrintSheet } from '@tnn/app-kit'
import type { ReactNode, RefObject } from 'react'
import classes from './sign.module.css'

/** An A4 page at 96 dpi: its width, and its least height */
const A4_WIDTH = 794
const A4_HEIGHT = 1123
/** The sheet's margins (12 mm, 14 mm below) at 96 dpi */
const SHEET_MARGINS = (12 + 14) * (96 / 25.4)

/** The A4 page at its own size, scaled to the screen's width; `short` (a bill), only as tall as what it prints */
export function ScaledPage({
  sheet,
  printRef,
  short,
  children,
}: {
  sheet: RefObject<HTMLDivElement | null>
  printRef: RefObject<HTMLDivElement | null>
  short?: boolean
  children: ReactNode
}) {
  const { ref: frame, width } = useElementSize()
  const { ref: inner, height } = useElementSize()
  const scale = width ? Math.min(1, width / A4_WIDTH) : 0
  const least = short ? 0 : A4_HEIGHT
  return (
    <div ref={frame} className={classes.frame} style={{ height: height ? Math.max(height + SHEET_MARGINS, least) * scale : undefined }}>
      <div
        ref={sheet}
        className={classes.sheet}
        style={{ transform: `scale(${scale})`, visibility: scale ? 'visible' : 'hidden', minHeight: short ? 0 : undefined }}
      >
        <div ref={inner}>
          <PrintSheet printRef={printRef}>{children}</PrintSheet>
        </div>
      </div>
    </div>
  )
}
